import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { fetchJson } from '@atlassian/jira-fetch';
import type { AtlassianAccount, GCGSJiraSpotlightResponse, GeneratedCJNContent } from './types.tsx';

const GCGS_JIRA_SPOTLIGHT_URL =
	'/gateway/api/gcg/api/v1/generate/team_growth/cross_join_nudge/jira_spotlight';

const ATLASSIAN_ACCOUNT_URL = '/gateway/api/me';

export const generateCJNContent = async (): Promise<GeneratedCJNContent> => {
	try {
		const me = await fetchJson<AtlassianAccount>(ATLASSIAN_ACCOUNT_URL);
		const response = await fetchJson<GCGSJiraSpotlightResponse>(GCGS_JIRA_SPOTLIGHT_URL, {
			method: 'POST',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				contact_name: me.nickname || me.name,
				domain: me.email.split('@')[1],
				product: 'confluence',
				job_title: me.extended_profile.job_title,
				department: me.extended_profile.department,
				team_type: me.extended_profile.team_type,
			}),
		});

		return {
			title: response.title,
			body: response.body,
			metadata: {
				companyName: response.metadata.company_name,
				firstName: response.metadata.first_name,
			},
			// TODO: GROOT-1944 we should remove special handling for this scenario and just throw when we have better overall handling in place that doesn't cause a snooze
			ready: response.status !== 'PROCESSING',
		};
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		fireErrorAnalytics({
			meta: {
				id: 'generateCJNContentFetchFailed',
				packageName: 'jiraCrossJoinNudges',
				teamName: 'groot-growth',
			},
			error,
		});
		throw new Error('Failed to generate nudge content');
	}
};
